export const generateNewTabName = () => {
  const crypto = window.crypto || window.msCrypto
  const array = new Uint32Array(1)
  return `_newTab${Math.ceil(crypto.getRandomValues(array) * 9999)}`
}
